var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUnselection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 0.999756C5.92572 0.999756 1 5.92451 1 11.9998C1 18.075 5.92524 22.9998 12.0005 22.9998C18.0762 22.9998 23.001 18.075 23.001 11.9998C23.001 5.92451 18.0762 0.999756 12.0005 0.999756ZM12.0005 4.28888C14.0106 4.28888 15.6394 5.91823 15.6394 7.92736C15.6394 9.93698 14.0106 11.5658 12.0005 11.5658C9.99135 11.5658 8.36249 9.93698 8.36249 7.92736C8.36249 5.91823 9.99135 4.28888 12.0005 4.28888ZM11.9981 20.1238C9.99328 20.1238 8.15713 19.3937 6.74087 18.1852C6.39587 17.8909 6.19679 17.4594 6.19679 17.0067C6.19679 14.969 7.84595 13.3382 9.88408 13.3382H14.1179C16.1565 13.3382 17.7993 14.969 17.7993 17.0067C17.7993 17.4599 17.6012 17.8904 17.2557 18.1847C15.84 19.3937 14.0033 20.1238 11.9981 20.1238Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnselection);
export default __webpack_public_path__ + "static/media/profileUnselection.9457643a626289700f3ff964e542a839.svg";
export { ForwardRef as ReactComponent };